import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Typography } from "@mui/material/";
import CircularProgress from "@mui/material/CircularProgress";
import actions from "../../../../Store/actions";
import { strings } from "../../../../common/i18n";
import MatReactTable from "../../../../common/components/MaterialReactTable";
import useColumnsRows from "./useColumnsRows";

/**
 * Audit Branches Component
 */
export default () => {
    const { auditsCreate } = useSelector((state) => state);
    const { rows, columns } = useColumnsRows();

    const dispatch = useDispatch();

    const setSelectedBranch = (selectedRowData) => {
        dispatch(
            actions.auditsCreate.create.itemSet({
                selectedBranches: selectedRowData.map((row) => row.id)
            })
        );
    };

    useEffect(() => {
        // Mark selected Branches based on row index
        const branchIds = auditsCreate.selectedBranches.map((id) => {
            const branchObj = auditsCreate.data.find((el) => el.id === id);
            return branchObj.branch;
        });

        // update data to indicate which branches are selected
        const selectedBranchData = auditsCreate.data.reduce((acc, item) => {
            const updItem = { ...item };
            branchIds.includes(item.branch)
                ? (updItem.selected = true)
                : (updItem.selected = false);
            acc.push(updItem);
            return acc;
        }, []);

        dispatch(
            actions.auditsCreate.create.itemSet({
                data: selectedBranchData
            })
        );
    }, [auditsCreate.selectedBranches]);

    const onRetry = () => {
        dispatch(actions.auditsCreate.create.update({ initError: false }));
        dispatch(actions.auditsCreate.create.init());
    };

    // The dealership list failed to load. Say so and offer a retry, instead of
    // a spinner that never ends.
    if (auditsCreate.data.length === 0 && auditsCreate.initError)
        return (
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    height: "100%",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <Typography>{strings("errorsUnexpected")}</Typography>
                <Button variant="outlined" onClick={onRetry}>
                    {strings("retry")}
                </Button>
            </Box>
        );

    if (auditsCreate.data.length === 0)
        return (
            <Box
                sx={{
                    display: "flex",
                    height: "100%",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <CircularProgress />
            </Box>
        );

    const initialRowSelection = auditsCreate.selectedBranches.reduce(
        (acc, id) => ({ ...acc, [String(id)]: true }),
        {}
    );

    return (
        <MatReactTable
            persistKey="auditCreateBranches"
            columns={columns}
            data={rows}
            loading={false}
            rowSelection={true}
            enableRowSelection={(row) => row.original.assetsCount > 0}
            onSelectionChange={setSelectedBranch}
            getRowId={(row) => String(row.id)}
            initialState={{
                sorting: [{ id: "branchName", desc: true }],
                rowSelection: initialRowSelection
            }}
            noRowsMessage={strings("messages.noAssets")}
        />
    );
};
